module.exports = "<div id=\"tree-temp\"></div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/Tree.html
// module id = 82
// module chunks = 0